<template>
  <div class="resetpwd_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('forgetpwe.reset') }}
      </div>
    </div>
    <form
      class="form"
      @submit.prevent="submit"
    >
      <div class="item">
        <input
          v-model.trim="data.mobile"
          type="text"
          class="inp"
          :placeholder="$t('forgetpwe.phoneNumber')"
        >
      </div>
      <div class="item">
        <input
          v-model.trim="data.code"
          type="text"
          class="inp"
          :placeholder="$t('forgetpwe.code')"
        >
        <van-count-down
          :time="time"
          class="btn get_captcha"
          @finish="timeCall"
        >
          <template v-slot="timeData">
            <span @click="sendcode">{{ timeData.seconds > 0 ? (timeData.minutes+':'+timeData.seconds) : $t('forgetpwe.send') }}</span>
          </template>
        </van-count-down>
      </div>
      <div class="item">
        <input
          v-model.trim="data.password"
          type="password"
          class="inp"
          :placeholder="$t('forgetpwe.newPassword')"
        >
      </div>
      <button
        type="submit"
        class="btn basic_btn"
      >
        {{ $t('forgetpwe.submit') }}
      </button>
    </form>
  </div>
</template>

<script>

    import Vue from 'vue';
    import {CountDown, Checkbox} from 'vant';
    import Fetch from '../../utils/fetch'

    Vue.use(CountDown).use(Checkbox);

    export default {
        name: "Register",
        data() {
            return {
                time: 0,
                data: {
                    mobile: '',
                    code: '',
                    password: '',
                }
            };
        },
        created() {
            this.$parent.footer('user',false);
        },
        mounted() {
        },
        methods: {
            timeCall() {
                this.is_send = false;
                this.time = 0;
            },
            sendcode() {

                if (this.is_send) {
                    return;
                }

                if (!this.data.mobile) {
                    this.$toast(this.$t('forgetpwe.phoneNumberEmpty'));
                    return;
                }

                this.is_send = true;

                Fetch("/index/forgetpwd_code", {
                    mobile: this.data.mobile,
					lang: this.$i18n.locale||"zh_cn"
                }).then(() => {
                    this.time = 120 * 1000;
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('forgetpwe.sendSuccess')
                    });
                }).catch(() => {
                    this.is_send = false;
                });

            },
            submit() {
                if (!this.data.mobile) {
                    this.$toast(this.$t('forgetpwe.phoneNumberEmpty'));
                    return;
                }

                if (!this.data.password) {
                    this.$toast(this.$t('forgetpwe.newPasswordEmpty'));
                    return;
                }

                if (!this.data.code) {
                    this.$toast(this.$t('forgetpwe.codeEmpty'));
                    return;
                }

                Fetch("/index/forgetpwd_nologin", {
                    mobile: this.data.mobile,
                    password: this.data.password,
                    code: this.data.code
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('forgetpwe.success')
                    });
                }).then(() => {
                    this.$router.replace('/login');
                })
            },
        }
    };
</script>

<style lang="less" scoped>
	
    .resetpwd_wrap .form {
        display: block;
        width: 95vw;
        margin: 0 auto;
        padding-top: 28px;
    }

    .resetpwd_wrap .form .item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-bottom: 20px;
    }

    .resetpwd_wrap .form .item .inp {
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        border-radius: 5px;
        border: 1px solid #eeeeee;
        font-size: 14px;
        height: 46px;
        padding: 0 10px;
        background: #fff;
    }


    .get_captcha {
        flex: 0 0 40%;
        margin-left: 10px;
        font-size: 16px;
        text-align: center;
        line-height: 45px;
        color: #FFFFFF;
        height: 45px;
        background: linear-gradient(90deg, #ff7791 0%, #ff5574 100%);
        border-radius: 8px;
    }

    .resetpwd_wrap .form .basic_btn {
        display: block;
        margin: 35px auto 0 auto;
    }

    .resetpwd_wrap {
        min-height: 100vh;
        padding-bottom: 88px;
        background: #fff;
        color: #16223a;
        box-sizing: border-box;
    }

    .resetpwd_wrap .red_top_bg {
        background: #fff;
        border-bottom: 1px solid #f0f2f5;
    }

    .resetpwd_wrap .form {
        width: auto;
        margin: 16px 16px 0;
        padding: 18px 16px 22px;
        border: 1px solid rgba(255, 93, 122, 0.16);
        border-radius: 14px;
        background: #fff;
        box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
        box-sizing: border-box;
    }

    .resetpwd_wrap .form .item {
        height: 46px;
        margin-bottom: 14px;
        border: 1px solid rgba(255, 93, 122, 0.18);
        border-radius: 10px;
        background: #fff6f8;
        overflow: hidden;
        box-sizing: border-box;
    }

    .resetpwd_wrap .form .item .inp {
        min-width: 0;
        height: 100%;
        border: 0;
        background: transparent;
        color: #16223a;
        caret-color: #ff5d7a;
        outline: none;
    }

    .resetpwd_wrap .form .item .inp::placeholder {
        color: #6d7688;
    }

    .resetpwd_wrap .form .item:focus-within {
        border-color: rgba(255, 93, 122, 0.52);
        box-shadow: 0 0 0 3px rgba(255, 93, 122, 0.1);
    }

    .get_captcha {
        flex: 0 0 112px;
        height: 100%;
        margin-left: 0;
        border-radius: 0;
        background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
        font-size: 13px;
        font-weight: 700;
        line-height: 44px;
    }

    .resetpwd_wrap .form .basic_btn {
        width: 100%;
        height: 44px;
        margin-top: 20px;
        border-radius: 10px;
        background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%) !important;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
    }

    @media screen and (max-width: 374px) {
        .resetpwd_wrap .form {
            margin-right: 12px;
            margin-left: 12px;
            padding-right: 12px;
            padding-left: 12px;
        }

        .get_captcha {
            flex-basis: 96px;
            font-size: 12px;
        }
    }
</style>
